<template>
  <div class="skeleton-field-list">
    <div
      v-for="index in length"
      :key="index"
      class="list"
    />
  </div>
</template>

<script>
export default {
  props: {
    length: {
      type: Number,
      default: 20,
    },
  },
};
</script>

<style lang="scss" scoped>
  .skeleton-field-list {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 6px;
    padding-left: 10px;

    .list {
      height: 35px;
      background-color: #F4F4F4;
      border-radius: 6px;
      animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }

    @keyframes pulse {
      50% {
        opacity: .5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/loading/jSkeletonComponentApp.vue